import * as angular from 'angular';
import {IPromise, IQService} from 'angular';
import {ViewSettingsRequestsService} from "./view-settings-requests.service";
import {
  ViewSettingsHolderType,
  ViewSettingsModel,
  ViewSettingsType
} from "../models/view-settings.model";
import {BringozLoaderService} from "./bringoz-loader.service";

export class ViewSettingsService {

  private siteDefaultHomePage: ViewSettingsModel;
  private userDefaultHomePage: ViewSettingsModel;
  private siteGeneralSettings: ViewSettingsModel;
  private userGeneralSettings: ViewSettingsModel;
  private siteFormSettings: ViewSettingsModel;
  private userFormSettings: ViewSettingsModel;

  constructor(private viewSettingsRequestsService: ViewSettingsRequestsService, private bringozLoaderService: BringozLoaderService, private $q: IQService) {
  }

  get getSiteDefaultHomePage() {
    return this.siteDefaultHomePage;
  }

  get getUserDefaultHomePage() {
    return this.userDefaultHomePage;
  }

  get getSiteGeneralSettings() {
    return this.siteGeneralSettings;
  }

  get getUserGeneralSettings() {
    return this.userGeneralSettings;
  }

  ////Setters
  set setSiteDefaultHomePage(settings: ViewSettingsModel) {
    this.siteDefaultHomePage = settings;
  }

  set setUserDefaultHomePage(settings: ViewSettingsModel) {
    this.userDefaultHomePage = settings;
  }

  set setSiteGeneralSettings(settings: ViewSettingsModel) {
    this.siteGeneralSettings = settings;
  }

  set setUserGeneralSettings(settings: ViewSettingsModel) {
    this.userGeneralSettings = settings;
  }

  set setSiteFormSettings(settings: ViewSettingsModel) {
    this.siteFormSettings = settings;
  }

  set setUserFormSettings(settings: ViewSettingsModel) {
    this.userFormSettings = settings;
  }

  get(pageName?: string, settingsTypes?: ViewSettingsType[]): IPromise<ViewSettingsModel[]> {
    const deferred = this.$q.defer<ViewSettingsModel[]>();

    this.bringozLoaderService.on();
    this.viewSettingsRequestsService.get(pageName, settingsTypes)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  getByUser(pageName?: string, settingsTypes?: string): IPromise<ViewSettingsModel[]> {
    const deferred = this.$q.defer<ViewSettingsModel[]>();

    this.bringozLoaderService.on();
    this.viewSettingsRequestsService.getByUser(pageName, settingsTypes)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getBySite(pageName?: string, settingsTypes?: string): IPromise<ViewSettingsModel[]> {
    const deferred = this.$q.defer<ViewSettingsModel[]>();

    this.bringozLoaderService.on();
    this.viewSettingsRequestsService.getBySite(pageName, settingsTypes)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  createByUser(viewSettings: ViewSettingsModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.viewSettingsRequestsService.createByUser(viewSettings)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateByUser(settingsId: string, viewSettings: ViewSettingsModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.viewSettingsRequestsService.updateByUser(settingsId, viewSettings)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteByUser(settingsId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.viewSettingsRequestsService.deleteByUser(settingsId)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  setSiteSettings(viewSettings: ViewSettingsModel[]) {
    const viewSettingsCopy = angular.copy(viewSettings).reverse();

    const userDefaultHomePageSettings = viewSettingsCopy?.find(dhp => dhp.holderType === ViewSettingsHolderType.User && dhp.settingsType === ViewSettingsType.HomePage);
    const siteDefaultHomePageSettings = viewSettingsCopy?.find(dhp => dhp.holderType === ViewSettingsHolderType.Site && dhp.settingsType === ViewSettingsType.HomePage);

    const userGeneralSettings = viewSettingsCopy?.find(gs => gs.holderType === ViewSettingsHolderType.User && gs.settingsType === ViewSettingsType.GeneralSettings);
    const siteGeneralSettings = viewSettingsCopy?.find(gs => gs.holderType === ViewSettingsHolderType.Site && gs.settingsType === ViewSettingsType.GeneralSettings);

    const userFormSettings = viewSettingsCopy?.find(gs => gs.holderType === ViewSettingsHolderType.User && gs.settingsType === ViewSettingsType.Form);
    const siteFormSettings = viewSettingsCopy?.find(gs => gs.holderType === ViewSettingsHolderType.Site && gs.settingsType === ViewSettingsType.Form);


    if (!!userDefaultHomePageSettings) this.setUserDefaultHomePage = userDefaultHomePageSettings;
    if (!!siteDefaultHomePageSettings) this.setSiteDefaultHomePage = siteDefaultHomePageSettings;

    if (!!userGeneralSettings) this.setUserGeneralSettings = userGeneralSettings;
    if (!!siteGeneralSettings) this.setSiteGeneralSettings = siteGeneralSettings;

    if (!!userFormSettings) this.setUserFormSettings = userFormSettings;
    if (!!siteFormSettings) this.setSiteFormSettings = siteFormSettings;
  }

}

angular
  .module('bringoz.admin.commons')
  .service('viewSettingsService', ViewSettingsService);
